import React, { FC } from 'react';
import BorderedListItem from '../../Templates/DefaultTemplate/Components/BorderedListItem/BorderedListItem';
import markerIcon from '../../../assets/icons/point-green.svg';
import primaryMarkerIcon from '../../../assets/icons/point-dark-blue.svg';
import * as classes from './LocationsListItem.module.scss';

interface Props {
  isPrimary?: boolean;
  title: string;
  description?: string;
  customMarker?: string;
}

const LocationsListItem: FC<Props> = ({ isPrimary, title, description, customMarker }) => {
  return (
    <BorderedListItem borderOnlyBottom>
      <div className={classes.wrapper}>
        <div>{isPrimary ? <img src={primaryMarkerIcon} alt='' /> : <img src={customMarker ? customMarker : markerIcon} alt='' />}</div>
        <div>
          <div className={classes.title}>{title}</div>
          {description && <div className={classes.description}>{description}</div>}
        </div>
      </div>
    </BorderedListItem>
  );
};

export default LocationsListItem;
